import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { API_URL } from '../config';
import './LoginForm.css';

function LoginForm() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [message, setMessage] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // kein Browser-Redirect
    setMessage('');
    const res = await login(formData.email, formData.password);
    if (res?.ok) navigate('/');
    else setMessage(res?.error || 'Login failed.');
  };

  const handleOAuth = (provider) => {
    const base = process.env.REACT_APP_API_URL || API_URL;
    window.location.href = `${base}/auth/google`;
  };

  return (
    <div className="login-box login-box--compact">{/* << kompakter */}
      <h2>Login to Versus-Arena</h2>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="input-group">
          <label htmlFor="homepage-email">Username / Email</label>
          <input 
            type="text" 
            id="homepage-email"
            name="email" 
            value={formData.email}
            onChange={handleChange} 
            placeholder="Username / Email" 
            autoComplete="username"
            required 
          />
        </div>
        <div className="input-group">
          <label htmlFor="homepage-password">Password</label>
          <input 
            type="password" 
            id="homepage-password"
            name="password" 
            value={formData.password}
            onChange={handleChange} 
            placeholder="Password" 
            autoComplete="current-password"
            required 
          />
        </div>

        <button type="submit" className="btn-outline-orange">Login</button>

        <p className="forgot-password-under">
          <Link to="/forgot-password" className="link-orange">Forgot password?</Link>
        </p>
      </form>

      {message && <p className="message error">{message}</p>}

      <p className="or-text">or</p>
      <div className="social-login">
        <button type="button" className="btn-google" onClick={() => handleOAuth('google')}>Google</button>
      </div>

      <p className="signup-text">
        Don't have an account? <Link className="link-orange" to="/register">Sign Up</Link>
      </p>
    </div>
  );
}

export default LoginForm;
